import React, { useState } from "react";
import { SiteProcessProps } from "./type";
import { CSSTransition } from "react-transition-group";
import "./index.scss";
import { Overlay } from "shared";
import { connect } from "react-redux";
import Icon from "shared/components/Icon";
import { formatDate } from "utils/DateUtils";
import t from "utils/Lang";

const SiteProcess = ({
  statusHistories = [],
  currentStep,
  siteStatistic,
}: SiteProcessProps) => {
  const statusHistoryVal = [...statusHistories];
  const dataProcessExtra =
    siteStatistic?.filter(
      (s) =>
        s.order_sequence_number > currentStep &&
        s.order_sequence_number < currentStep + 2
    ) || [];
  statusHistoryVal.push(...dataProcessExtra);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const renderProcessItem = (item: any, index: number) => {
    const iconName =
      item.order_sequence_number < currentStep ? "check" : "hourglass_empty";
    const type =
      item.order_sequence_number < currentStep ? "completed" : "in-progress";
    return (
      <div
        key={`${item.order_sequence_number}-${index}`}
        className="site-process__item"
      >
        <div className="site-process__step">
          <div
            className={`${index == 0 ? "hide-line" : ""} site-process__line`}
          />
          <Icon
            size="small"
            customClassName={`site-process__icon-${type}`}
            name={iconName}
          />
          <div
            className={`${
              index == statusHistoryVal.length - 1 ? "hide-line" : ""
            } site-process__line`}
          />
        </div>
        <div className="site-process__info">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>
              <span className={`name-${type}`}>{item.name}</span>
              {item.created_by && (
                <span style={{ fontWeight: 400 }}>
                  {" "}
                  bởi <span style={{ fontWeight: 600 }}>{item.created_by}</span>
                </span>
              )}
            </span>
            <span className="site-process__item__date">
              {formatDate(item.created_on, `DD @ MM, YYYY # HH:mm`)
                .replace("@", "tháng")
                .replace("#", "lúc") || "Chưa tiến hành"}
            </span>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="site-process__toggle normal-button" onClick={toggle}>
        <span className="site-process__toggle__title">
          {t().site_detail__processing}
        </span>
        <i className="material-icons" style={{ marginTop: 8 }}>
          keyboard_arrow_down
        </i>
      </div>
      {isOpen && <Overlay zIndex={1000} onClick={toggle} />}
      <CSSTransition
        in={isOpen}
        timeout={300}
        classNames="sidebar-right"
        unmountOnExit
        onEnter={() => {}}
        onExited={() => {}}
      >
        <div className="site-process__body">
          <div
            className="site-process__body__close normal-button"
            onClick={toggle}
          >
            <i className="material-icons">keyboard_arrow_right</i>
          </div>
          <div className="site-process__body__container">
            <span className="site-process__body__title">
              {t().site_detail__processing}
            </span>
            <div className="site-process__item-container">
              {statusHistoryVal?.map(renderProcessItem)}
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    siteStatistic: state.site.siteStatistic,
  };
};

export default connect(mapStateToProps)(SiteProcess);
